import isLongerThan from './isLongerThan'

// returns true if input array's length is more than 0

const isLong = isLongerThan(0)

export default isLong